import type { Bank } from 'modules/crm/types';
import { createSelectField } from './createSelectField';

export const bankFieldProps = {
  getOptionLabel: (a: Bank) => `${a.title} (${a.code})`,
  getOptionValue: (a: Bank) => a.id.toString(),
};
export const BankField = createSelectField<Bank>('core/banks/', bankFieldProps);
